import React, { useEffect } from 'react';
import './Team.css';
import borderImage from '../assets/border.png';
import usePageTitle from '../hooks/usePageTitle';

const Team: React.FC = () => {
  usePageTitle('Team');
  
  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo(0, 0);
    
    // Remove animation classes first to reset
    const titleElement = document.querySelector('.team-title');
    const leftCards = document.querySelectorAll('.mentor-card.left-column');
    const rightCards = document.querySelectorAll('.mentor-card.right-column');
    
    if (titleElement) {
      titleElement.classList.remove('animate-in-initial');
    }
    
    leftCards.forEach(card => {
      card.classList.remove('slide-in-left');
    });
    rightCards.forEach(card => {
      card.classList.remove('slide-in-right');
    });
    
    // Force reflow
    void document.body.offsetHeight;
    
    // Animate title first
    if (titleElement) {
      setTimeout(() => {
        titleElement.classList.add('animate-in-initial');
      }, 200);
    }
    
    // Animate cards with staggered timing after title
    leftCards.forEach((card, index) => {
      setTimeout(() => {
        card.classList.add('slide-in-left');
      }, 600 + index * 150);
    });
    
    rightCards.forEach((card, index) => {
      setTimeout(() => {
        card.classList.add('slide-in-right');
      }, 600 + index * 150);
    });
  }, []);

  const mentors = [
    {
      name: "Joseph Choi",
      credentials: [
        "UMass Amherst | Pre-Med & Bio",
        "Principal Consultant",
        "Boarding School Guardian Angel",
        "Comedy Enthusiast",
        "Steak Extraordinaire"
      ]
    },
    {
      name: "Irene Ju",
      credentials: [
        "Harvard | Classics & Literature",
        "Admissions Interviewer",
        "NLE 6x Gold",
        "All-State Piccoloist",
        "Creative Writer"
      ]
    },
    {
      name: "Richard Lun",
      credentials: [
        "Harvard | Comp Sci & Psych",
        "Material Science Researcher",
        "Siemens Finalist",
        "Software Engineer",
        "Music Producer"
      ]
    },
    {
      name: "William Cooper",
      credentials: [
        "Harvard | Mechanical Engineering",
        "MOP Qualifier",
        "Boarding School Sage",
        "Economics Enthusiast",
        "Bass Guitarist"
      ]
    },
    {
      name: "Vivian Wang",
      credentials: [
        "Cornell | Art & Architecture",
        "Built Environment Designer",
        "UI/UX Specialist",
        "Media Aesthetics",
        "Tennis Prodigy"
      ]
    },
    {
      name: "Robert Lee",
      credentials: [
        "Brandeis | Economics",
        "Boarding School Guide",
        "SAT/Subject Test Instructor",
        "Market Analyst",
        "Bostonian at Heart"
      ]
    },
    {
      name: "Yao Yin",
      credentials: [
        "Harvard | Physics",
        "UW Theoretical Physics Ph.D.",
        "Quantum Wanderer",
        "Cherry Wood Alchemist",
        "Global Nomad"
      ]
    },
    {
      name: "Ryan Kim",
      credentials: [
        "MIT | Applied Math",
        "Mathematics Researcher",
        "Multi-Olympiad Medalist",
        "Quantitative Trader",
        "American Ninja Warrior"
      ]
    },
    {
      name: "Jina Lee",
      credentials: [
        "Columbia | Anthropology",
        "Cultural Research Specialist",
        "SSAT Instructor",
        "Quadrilingual Speaker",
        "Coffee Connoisseur"
      ]
    },
    {
      name: "Feven Seifu",
      credentials: [
        "Harvard | Political Science",
        "Harvard Law JD",
        "Rhodes Scholar Finalist",
        "Political Campaign Strategist",
        "Neuroscience Enthusiast"
      ]
    }
  ];

  return (
    <div className="team-page">
      <h1 className="team-title">Our Mentors</h1>
      <img src={borderImage} alt="" className="team-border-image" />
      <div className="team-content">
        {[0, 2, 4, 6, 8].map((rowIndex) => (
          <div key={rowIndex} className={`mentor-row ${rowIndex / 2 % 2 === 0 ? 'white' : 'gray'}`}>
            <div className="mentor-container">
              <div className="mentor-grid">
                {[0, 1].map((colIndex) => {
                  const mentorIndex = rowIndex + colIndex;
                  if (mentorIndex < mentors.length) {
                    const mentor = mentors[mentorIndex];
                    return (
                      <div key={colIndex} className={`mentor-card ${colIndex === 0 ? 'left-column' : 'right-column'}`}>
                        <h2 className="mentor-name">{mentor.name}</h2>
                        <div className="mentor-credentials">
                          {mentor.credentials.map((credential, idx) => (
                            <p key={idx}>{credential}</p>
                          ))}
                        </div>
                      </div>
                    );
                  }
                  return null;
                })}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Team;